import { Card } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { termsOfServiceStepIndex } from "../../../../ClientOnboarding.common.utils";
import { useCobConfig } from "../../../../CobConfigContext";
import styles from "./TermsOfService.module.scss";
import { TermsOfServiceContent } from "./TermsOfServiceContent";
import { jsx as _jsx } from "react/jsx-runtime";
export const {
  TermsOfServicesTestIds
} = getTestIds();
export const TermsOfService = _ref => {
  var _termsOfServiceStepIn, _relationship$legalTe;
  let {
    currentStep
  } = _ref;
  const {
    relationship
  } = useCobConfig();
  const termsOfServiceIndex = (_termsOfServiceStepIn = termsOfServiceStepIndex[currentStep]) !== null && _termsOfServiceStepIn !== void 0 ? _termsOfServiceStepIn : 0;
  const termsOfService = (_relationship$legalTe = relationship.legalTermsDocuments) === null || _relationship$legalTe === void 0 ? void 0 : _relationship$legalTe[termsOfServiceIndex];
  if (!termsOfService) {
    return null;
  }
  return /*#__PURE__*/_jsx(Card, {
    className: styles.card,
    testId: TermsOfServicesTestIds.Root(),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/_jsx(TermsOfServiceContent, {
        relationship: relationship,
        termsOfService: termsOfService
      })
    })
  });
};